








import {computed, defineComponent} from "@vue/composition-api";

export default defineComponent({
  props: {
    text: String,
    isHelp: Boolean
  },
  setup(props, context) {
  },
})
